<template>
  <div v-show="visible" class="part mt-4">
    <div class="header_style justify-content-start">
      <h2 class="h2_style mb-0">Brightness</h2>
    </div>

    <div class="part__cnt">
      <div v-if="labelsHasData" class="label_style mt-3">
        <ul v-for="item in labels" :key="item.label">
          <li>{{ item.label }}</li>
          <li>{{ (item.value || item.value === 0) ? item.value : '-'}}</li>
        </ul>
      </div>

      <div v-show="hasData(dataFields)" class="position-relative mt-3">
        <div :id="chartDomId" style="width: 100%; height: 400px"></div>
        <label-list ref="labelList1" :perf_second_data="perf_second_data" :chartKey="chartKey" />
        <chart-rect ref="chartRect1" :chartKey="chartKey" />
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import LabelList from '../label-list.vue'
import {allChart, arrNotEmpty} from '../common.js'
import ChartRect from '../rect.vue'

const useCharts = {
  props: {
    chartSettings: Object,
    perf_second_data: Object,
  },

  data() {
    return {
      seriesInfo: [
        {name: 'Brightness', dataKey: 'Brightness'},
      ],
      chartDomId: 'brightness',
      chartKey: 'brightness_chart',
    }
  },

  computed: {
    secondData() {
      return this.perf_second_data?.['每秒数据']?.rows || {}
    },

    xData() {
      return this.secondData?.timeline || []
    },

    dataFields() {
      return this.seriesInfo.map(item => item.dataKey)
    }
  },

  methods: {
    getOption() {
      return {
        title: {
          text: "Brightness",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series: this.seriesInfo.map(item => {
          return {
            name: item.name,
            data: this.secondData?.[item.dataKey],
            type: "line",
            showSymbol: false,
            itemStyle: this.chartSettings.itemStyle2,
          }
        }),
      }
    },

    drawChart() {
      let chartDom = document.getElementById(this.chartDomId)
      if (!chartDom) return
      if (!allChart?.[this.chartKey]) {
        allChart[this.chartKey] = echarts.init(chartDom)
      }
      allChart?.[this.chartKey].setOption(this.getOption(), {notMerge: true})
    },
  }
}

export default {
  mixins: [useCharts],
  
  inject: ['injectObj', 'hasData'],

  components: {LabelList, ChartRect},

  props: {
    testInfo3: Object,
    testInfo: Object,
    testInfo0: Object,
    testInfo2: Object,
  },

  data() {
    return {

    }
  },

  computed: {
    isAllChecked() {
      return this.injectObj.isAllChecked
    },

    labels() {
      let data = this.testInfo3

      return [
        {
          label: "Avg(Brightness)",
          value: data?.['Avg(Brightness)'],
        },
      ]
    },

    labelsHasData() {
      return arrNotEmpty(this.labels)
    },

    visible() {
      return this.labelsHasData || this.hasData(this.dataFields)
    },
  },

  methods: {
    async init(isMounted) {
      this.drawChart()
      await this.$nextTick()
      this.$refs.chartRect1?.init(isMounted)
    }
  }
}
</script>

<style scoped>
@import "../common.css"
</style>